import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import TagDropdownMenu from './components/TagDropdownMenu';

// Keys of the forum payload's helpRulesMenus - see HelpRulesMenus.php.
const RULES_TAG_SLUG = 'regles';
const HELP_TAG_SLUG = 'aide';

// Adds "Règles et aide" to the header's *secondary* item list (search,
// locale switcher, notifications/session) rather than the primary one
// (Accueil, Espèces, Articles, Forums, Divers) - explicitly requested to
// sit on the right, next to search, matching champis.net's own layout
// (Accueil…Divers on the left, then Accès rapide/Règles/Aide/
// S'enregistrer/Connexion clustered on the right). One menu, with a
// section for each (requested 2026-10-05), rather than the two menus
// champis.net had. Priority 26 slots it directly between search (30) and
// the locale switcher (20) - see HeaderSecondary.js's own items().
export default function addHelpRulesMenus() {
  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.add('champisHelpRulesMenu', m(TagDropdownMenu, {
      sections: [{
        tagSlug: RULES_TAG_SLUG,
        label: app.translator.trans('champis-help_rules.forum.help_rules_menu.rules_group')
      }, {
        tagSlug: HELP_TAG_SLUG,
        label: app.translator.trans('champis-help_rules.forum.help_rules_menu.help_group')
      }],
      label: app.translator.trans('champis-help_rules.forum.help_rules_menu.label'),
      toggleLabel: app.translator.trans('champis-help_rules.forum.help_rules_menu.toggle_accessible_label')
    }), 26);
  });
}